export default __webpack_public_path__ + "fonts/solution_bg.24fe3b66ed6a1097ee97fa7fafde90dc.jpg";